import React from 'react'
import Button from '@elements/button'
import { useTranslations } from 'next-intl';
import ImagePrepare from '@elements/imagePrepare';
import Image from "next/legacy/image";
import CheckedListItem from '@svg/CheckedListItem';
import { useRouter } from 'next/router';
interface Props {
    onConfirm: () => void;
    onCancel: () => void;
}

const WrappingDonation = ({
    onConfirm,
    onCancel
}: Props) => {
    const t = useTranslations();
    const { locale } = useRouter();
    return (
        <div dir={locale?.includes("ar-") ? "rtl" : "ltr"} className='py-8 flex flex-col text-start px-6'>
            <div className="w-20 mx-auto">
                <Image width={86} height={86} alt='gift-bag' src='/imgs/gift-bag.png' />
            </div>
            <h2 className='font-bold text-xl mb-4'>{t("This Ramadan Give More with Dabdoob")}</h2>
            <p className='text-gray-600 mb-6'>
                {t("Skip the gift wrapping and well contribute a fixed amount to UNHCRs efforts to support refugee children in need")}
            </p>
            <p className='mt-4  text-gray-600'>{t("What This Means for You")}</p>
            <ul className='mt-4 space-y-2 font-medium text-start'>
                <li className='flex items-center gap-2'>
                    <div className="w-4">
                        <CheckedListItem />
                    </div>
                    {t("Youve opted out of gift wrapping")}
                </li>
                <li className='flex items-center gap-2'>
                    <div className="w-4">
                        <CheckedListItem />
                    </div>
                    {t("Youll receive your order in our paper bag")}
                </li>
                <li className='flex items-center gap-2'>
                    <div className="w-4">
                        <CheckedListItem />
                    </div>
                    {t("Well contribute the fixed amount to the UNHCR UN Refugee Agency")}
                </li>
            </ul>
            <p className='mt-4 mb-6  text-gray-600'>{t("Ready to make a difference")}</p>
            <div className="flex gap-4 font-bold flex-wrap items-center justify-center">
                <Button
                    className='rounded-full text-blue-500 border-gray-500 w-full '
                    theme='secondary'
                    onClick={onCancel}
                >
                    {t("No Id like gift wrapping")}
                </Button>
                <Button
                    className='rounded-full !shadow-[0px_8px_24px_0px_rgba(0,138,246,0.32)] w-full '
                    onClick={onConfirm}
                >
                    {t("Yes contribute")}
                </Button>
            </div>
        </div>
    )
}

export default WrappingDonation